import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'portal-ui-common-error',
  standalone: true,
  imports: [],
  template: `<p>Something went wrong. Kindly try again.</p>`,
  styles: [':host {display: block}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonErrorComponent {}
